import React, { useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { Popover, Modal, Pagination } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getCommentListLoad } from "../../redux/slices/inner.slice";
import images from "../../themes/appImage";
import { imageURL } from "../../redux/Api/apikit";

const InnerImgCard = ({
  avatarSrc,
  file,
  postType,
  username,
  time,
  description,
  hugSrc,
  happyFace,
  partyFace,
  redHeart,
  smileyFace,
  smileyHeart,
  comment,
  id,
}) => {
  const fileString = `${imageURL}${file}`;
  const dispatch = useDispatch();
  const { commentListData } = useSelector((state) => state.InnerCircleReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const [visible, setVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const commentsPerPage = 5; // Number of comments per page

  const handelClick = () => {
    const data = {
      limit: 10,
      offset: 0,
      post: id
    };
    dispatch(getCommentListLoad(data));
    setIsModalVisible(true);
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClose = () => {
    setIsModalVisible(false);
    setCurrentPage(1); // Reset to first page when closing the modal
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const content = (
    <div className="flex items-center">
      <div className="mr-2 flex gap-1">
        <img src={images.hug} alt="hug" />
        <div className="text-[#2F2F2FCC]">{smileyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.EyeBrows} alt="eyebrows" />
        <div className="text-[#2F2F2FCC]">{happyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.love} alt="love" />
        <div className="text-[#2F2F2FCC]">{redHeart}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.party} alt="party" />
        <div className=" text-[#2F2F2FCC]">{partyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.smileyHeart} alt="smileyHeart" />
        <div className=" text-[#2F2F2FCC]">{smileyHeart}</div>
      </div>
    </div>
  );

  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = commentListData.slice(indexOfFirstComment, indexOfLastComment);
  console.log(commentListData, "commentListData");

  return (
    <div className="border border-royalPurple rounded-[20px]">
      <div className="p-4">
        <div className="flex gap-2 mb-2">
          <div>
            <img
              src={avatarSrc}
              alt="avatar"
              className="w-[40px] h-[40px] object-contain"
            />
          </div>
          <div className="flex flex-col justify-between">
            <div className="text-sm font-semibold text-dark">{username}</div>
            <div className="text-xs text-gray60 font-normal">
              {moment(time).utc().fromNow()}
            </div>
          </div>
        </div>
        <div className="text-base font-normal break-words text-dark mb-4">
          {description}
        </div>
      </div>
      <div>
        {postType === "textWithGIF" && fileString && (
          <>

            <img src={fileString} alt="gif" className="w-full" />
          </>
        )}
        {postType === "gifOnly" && fileString && (
          <img src={fileString} alt="gif" className="w-full" />
        )}
        {postType === "imageWithText" && fileString && (
          <>
            <img src={fileString} alt="image" className="w-full" />
          </>
        )}
        {postType === "postOnly" && fileString && (
          <>
            <img src={fileString} alt="image" className="w-full" />
          </>
        )}
        {postType === "videoWithText" && fileString && (
          <video width="600" controls>
            <source src={fileString} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="flex justify-between items-center p-4">
        <div className="flex justify-center items-center gap-2">
          <div>
            <EllipsisOutlined />
          </div>
          <Popover
            content={content}
            trigger="click"
            open={visible}
            onOpenChange={handleVisibleChange}
          >
            <div
              className="bg-background flex"
              onClick={() => handleVisibleChange(!visible)}
            >
              <div>
                <img src={images.hug} alt="hug" />
              </div>
              <div>
                <img src={images.EyeBrows} alt="eyebrows" />
              </div>
              <div>
                <img src={images.love} alt="love" />
              </div>
            </div>
          </Popover>
          <div className="text-gray60 font-normal cursor-pointer" onClick={handelClick}>
            {comment} Comments
          </div>
        </div>
        <div className="flex items-center gap-2">
          {/* <div className="bg-background rounded-full my-shadow p-2">
            <img src={images.commentImg} alt="comment" />
          </div>
          <div className="bg-purple rounded-full my-shadow p-2">
            <img src={hugSrc} alt="emoji" />
          </div> */}
        </div>
      </div>

      <Modal
        title="Comments"
        open={isModalVisible}
        onCancel={handleClose}
        footer={null}
        centered
      >
        {currentComments && currentComments.length > 0 ? (
          currentComments.map((comment) => (
            <div key={comment?._id} className="mb-4">
              <div className="flex items-center mb-2">
                <img
                  src={`${imageURL}${comment?.userDetail?.avatar}`}
                  alt="avatar"
                  className="w-[40px] h-[40px] object-contain mr-2"
                />
                <div className="flex flex-col">
                  <div className="text-sm font-semibold">
                    {comment?.userDetail?.userName}
                  </div>
                  <div className="text-xs text-gray60 font-normal">
                    {moment(comment?.createdAt).utc().fromNow()}
                  </div>
                </div>
              </div>
              <div className="text-base font-normal text-dark">
                {comment?.comment}
              </div>
            </div>
          ))
        ) : (
          <div>No comments</div>
        )}
        <Pagination
          current={currentPage}
          total={commentListData?.length}
          pageSize={commentsPerPage}
          onChange={handlePageChange}
          className="mt-4 text-center"
        />
      </Modal>
    </div>

  );
};

export default InnerImgCard;
